import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface ValueItem {
  icon: string;
  title: string;
  description: string;
}

const MissionVisionValues = () => {
  const values: ValueItem[] = [
  {
    icon: 'ShieldCheckIcon',
    title: 'Quality Excellence',
    description: 'Uncompromising commitment to international standards and best practices in every project'
  },
  {
    icon: 'UserGroupIcon',
    title: 'Client Partnership',
    description: 'Building long-term relationships through transparency, reliability, and exceptional service'
  },
  {
    icon: 'LightBulbIcon',
    title: 'Innovation',
    description: 'Leveraging cutting-edge technology and engineering solutions for optimal results'
  },
  {
    icon: 'HeartIcon',
    title: 'Safety First',
    description: 'Zero-incident culture with rigorous safety protocols protecting our team and clients'
  },
  {
    icon: 'GlobeAltIcon',
    title: 'Regional Impact',
    description: 'Contributing to Africa\'s infrastructure development and economic growth'
  },
  {
    icon: 'AcademicCapIcon',
    title: 'Continuous Learning',
    description: 'Investing in team development and staying ahead of industry advancements'
  }];


  return (
    <section className="py-20 bg-card">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-headline text-4xl md:text-5xl font-bold text-primary mb-4">
              Our Foundation
            </h2>
            <p className="font-body text-xl text-muted-foreground max-w-3xl mx-auto">
              Guided by clear principles and unwavering commitment to excellence
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <div className="bg-gradient-to-br from-primary to-secondary rounded-lg p-8 text-white shadow-card">
              <div className="flex items-center gap-3 mb-4">
                <Icon name="FlagIcon" size={40} variant="solid" className="text-accent" />
                <h3 className="font-headline text-3xl font-bold">Our Mission</h3>
              </div>
              <p className="font-body text-lg leading-relaxed">
                To deliver world-class electrical and mechanical engineering solutions that power Africa's growth, combining technical excellence with direct manufacturer partnerships to ensure mission-critical infrastructure projects exceed international standards while fostering sustainable development across the region.
              </p>
            </div>

            <div className="bg-gradient-to-br from-accent to-warning rounded-lg p-8 text-white shadow-card">
              <div className="flex items-center gap-3 mb-4">
                <Icon name="EyeIcon" size={40} variant="solid" className="text-primary" />
                <h3 className="font-headline text-3xl font-bold">Our Vision</h3>
              </div>
              <p className="font-body text-lg leading-relaxed">
                To be recognized as Africa's most trusted and innovative EPC contractor, setting the benchmark for engineering excellence, safety, and reliability while expanding our regional footprint and empowering communities through infrastructure development that transforms lives and drives economic prosperity.
              </p>
            </div>
          </div>

          <div>
            <h3 className="font-headline text-3xl font-bold text-primary mb-8 text-center">Core Values</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {values.map((value) =>
              <div
                key={value.title}
                className="bg-surface rounded-lg p-6 hover:shadow-card transition-all duration-250 transform hover:-translate-y-1">

                  <div className="bg-primary rounded-full w-16 h-16 flex items-center justify-center mb-4">
                    <Icon name={value.icon as any} size={32} variant="solid" className="text-white" />
                  </div>
                  <h4 className="font-headline text-xl font-semibold text-primary mb-2">{value.title}</h4>
                  <p className="font-body text-muted-foreground">{value.description}</p>
                </div>
              )}
            </div>
          </div>

          <div className="mt-16 bg-surface rounded-lg overflow-hidden shadow-card">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="relative h-64 lg:h-auto">
                <AppImage
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_1610c55e9-1764720226721.png"
                  alt="Professional engineering team in safety gear reviewing technical blueprints at construction site with industrial equipment in background"
                  className="w-full h-full object-cover" />

              </div>
              <div className="p-8 flex flex-col justify-center">
                <h3 className="font-headline text-2xl font-bold text-primary mb-4">Leadership Team</h3>
                <p className="font-body text-muted-foreground mb-6">
                  Our executive team brings over 100 combined years of engineering expertise, with credentials from leading international institutions and proven track records in delivering complex infrastructure projects across Africa.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default MissionVisionValues;